// frontend/src/pages/LoginPage.jsx
// 登入頁面

import { Container, Box, Typography } from '@mui/material';
import Login from '../components/Auth/Login';

const LoginPage = () => {
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography component="h1" variant="h4" sx={{ mb: 4 }}>
          佛法搜尋資料庫
        </Typography>
        <Typography variant="h5" sx={{ mb: 3 }}>
          使用者登入
        </Typography>
        <Login />
      </Box>
    </Container>
  );
};

export default LoginPage;
